import { render, staticRenderFns } from "./ClientDocumentsList.vue?vue&type=template&id=110ac1ac&"
import script from "./ClientDocumentsList.vue?vue&type=script&lang=js&"
export * from "./ClientDocumentsList.vue?vue&type=script&lang=js&"
import style0 from "./ClientDocumentsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports